var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root d-flex flex-row h-100" }, [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.contents,
          expression: "contents"
        }
      ],
      staticClass: "col pl-1",
      class: _vm.theme,
      attrs: { disabled: _vm.readOnly, "data-title": _vm.title },
      domProps: { value: _vm.contents },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.contents = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }